import {View} from 'native-base';
import React, {ReactElement, useEffect, useRef, useState} from 'react';
import {Animated, Easing, Platform} from 'react-native';

export interface FilterBarAccordionProps {
  toggle?: boolean;
  accordionTop: ReactElement;
  accordionBody: ReactElement;
}

const FilterBarAccordion: React.FC<FilterBarAccordionProps> = ({
  toggle,
  accordionTop,
  accordionBody,
}) => {
  const showAnimHeightValue = useRef(new Animated.Value(0)).current;
  const [isOpen, setIsOpen] = useState(false);
  const [containerHeight, setContainerHeight] = useState<number>(250);

  useEffect(() => {
    if (toggle) {
      setIsOpen(true);
      Animated.sequence([
        Animated.timing(showAnimHeightValue, {
          toValue: 1,
          duration: 500,
          easing: Easing.inOut(Easing.cubic),
          useNativeDriver: false,
        }),
      ]).start();
    } else {
      Animated.sequence([
        Animated.timing(showAnimHeightValue, {
          toValue: 0,
          duration: 500,
          easing: Easing.inOut(Easing.cubic),
          useNativeDriver: false,
        }),
      ]).start(() => {
        setIsOpen(false);
      });
    }
  }, [showAnimHeightValue, toggle]);

  const maxHeightVal = showAnimHeightValue.interpolate({
    inputRange: [0, 1],
    outputRange: [0, containerHeight],
  });

  const isWeb = Platform.OS === 'web';

  return (
    <View>
      {accordionTop}
      {isOpen && isWeb && (
        <Animated.View style={{overflow: 'hidden', maxHeight: maxHeightVal}}>
          <View
            onLayout={({
              nativeEvent: {
                layout: {height},
              },
            }) => {
              setContainerHeight(height);
            }}>
            {accordionBody}
          </View>
        </Animated.View>
      )}
      {isOpen && !isWeb && (
        <View
          onLayout={({
            nativeEvent: {
              layout: {height},
            },
          }) => {
            setContainerHeight(height);
          }}>
          {accordionBody}
        </View>
      )}
    </View>
  );
};

export default FilterBarAccordion;
